export const API = {
  documentsOwned: '/api/v1/documents/owned',
  documentsPublic: (search = "") => `/api/v1/documents/public${search ? "?" + search : ""}`,
  tagsPath: '/api/v1/tags',
  createDocument: '/api/v1/documents',
  document: (id) => `/api/v1/documents/${id}`,
  cloneDocument: (id) => `/api/v1/documents/${id}/clone`,
  favoriteDocument: (id) => `/api/v1/documents/${id}/favorite`,
  uploadImage: '/api/v1/images',
};

export async function uploadImage(file) {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(API.uploadImage, {
    method: 'POST',
    headers: { ...(csrf && { 'X-CSRF-Token': csrf }) },
    body: formData,
  });

  if (!res.ok) {
    const json = await res.json().catch(() => ({}));
    throw new Error(json.error || 'Upload failed');
  }

  const { url, image_id } = await res.json();
  return { url, imageId: image_id };
}
